var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4453416(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 340.59 247.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#bfd2fa;}.cls-4{fill:#7c9af2;}.cls-13,.cls-17,.cls-21,.cls-5{fill:#fff;}.cls-6{fill:#93b6f8;}.cls-7{fill:#0b055b;}.cls-8{fill:#6376cc;}.cls-9{fill:#d4dafd;}.cls-10{clip-path:url(#clip-path-2);}.cls-11{fill:#8897eb;}.cls-12{fill:#bcc4f7;}.cls-13{opacity:0.62;}.cls-14{fill:#4c51ed;}.cls-15{fill:#e2605e;}.cls-16{fill:#b08bfa;}.cls-17{opacity:0.76;}.cls-18{fill:#91b9f7;}.cls-19{fill:#f3f3f3;}.cls-20{fill:#606060;opacity:0.18;}.cls-21{font-size:4px;font-family:Montserrat-ExtraBoldItalic, Montserrat ExtraBoldItalic;font-weight:800;font-style:italic;letter-spacing:0.2em;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-353.41 -126.17)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.74,
    y: 68.3,
    width: 580.51,
    height: 359.82
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-353.41 -126.17)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 417.6,
    y: 219.09,
    width: 193.45,
    height: 124.8
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M536.29,126.86c-19.44,1.61-38.89,3.4-56.25,13.45a47.35,47.35,0,0,0-18.24,18.18c-4.32,8-6.33,16.94-8.52,25.73-3.43,13.83-8.25,27.53-19.64,36.8-11.74,9.56-26.45,15.14-40.64,20-16.72,5.7-29.74,19.15-36.25,35.84a51.45,51.45,0,0,0,.78,38.41c6.38,14.65,19.23,26.92,34.3,34.33.16.08.46-1.16.64-1.16H653.93c9.87,0,21.85.15,28.15-7.92,13.31-17,14.71-38.71,8-58.28-5.7-16.57-18.21-28.6-28.78-42.56-10.75-14.2-10-39.47-14.83-55.55-12.43-41.33-66.93-60.85-106-57.59Z",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.36,
    y: 24.04,
    width: 55.8,
    height: 55.8,
    rx: 7.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M450.69,184.21l2.37-2.84a4.25,4.25,0,0,0,3.42,2c1.71,0,2.61-1,2.61-3.06v-8.77h-6.48v-3.42h10.72v12c0,4.55-2.29,6.79-6.64,6.79A7.41,7.41,0,0,1,450.69,184.21Z",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M466.1,184.77l1.44-3.22a10.83,10.83,0,0,0,6.09,1.93c2.53,0,3.55-.85,3.55-2,0-3.45-10.71-1.08-10.71-7.93,0-3.13,2.52-5.74,7.76-5.74a12.36,12.36,0,0,1,6.4,1.64l-1.31,3.24a10.39,10.39,0,0,0-5.11-1.45c-2.53,0-3.51,1-3.51,2.1,0,3.4,10.72,1.06,10.72,7.83,0,3.08-2.55,5.71-7.82,5.71A13.15,13.15,0,0,1,466.1,184.77Z",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M581.26,271c10.78,7.71,52.17,5.76,61.07-3.47,2.53-2.62,6.08-9-2.72-14.32-5.84-3.52-6.71-1.47-12.21-4.86-2.19-1.35-7.13-6.67-.41-10.28,3.41-1.83,10.43-1.3,15.34-2,2.18-.33,9.82-2,10.47-7.57.34-3-1.72-7.73-8.1-8.08-1.38-.08-6.16-1.59-6.08-4.66,0,0,.74-6.07,7.45-4.82,0,0,15.49,1.8,15-7.72-.11-2.11-1.56-5.12-8-4.84,0,0-6.82-.91-4.26-5.58,0,0,.67-.88,4.88-3.73,0,0,15.51-8.89,4.28-17.2-2.95-2.18-8.77-4.7-14.4,2.94,0,0-4.69,9.52-7.83,4.62-2-3.13-6-11.47-13.92-6.38-1.29.83-4.75,5.66,1.14,13.81,1.26,1.75,3.61,6.26,1.52,9.37-.38.57-6.85,8.77-13.11-4.31-1.74-3.64-10.92-10.59-16.24-2.31-5.12,8-1,18.14,2.52,23,4.44,6.18,4.56,12.75.53,13.84a6.53,6.53,0,0,1-7.2-4.42c-1.32-4.62-3.07-17-15.94-12.46-6.64,2.32-5.71,11.72-5,24.75C570.77,246.78,573,265.07,581.26,271Z",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M583.15,265.46l0,0a.24.24,0,0,1-.05-.34c2.76-3.63,67.61-88.91,70.3-90.5a.24.24,0,0,1,.33.08.25.25,0,0,1-.08.34c-2.09,1.23-46.8,59.66-70.15,90.37A.24.24,0,0,1,583.15,265.46Z",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M639.25,196.63c-1.32-.68-2.2-1.18-2.33-1.26l-.08-.08c-.36-.55-8.74-13.44-8.92-16.71a.26.26,0,0,1,.24-.26.25.25,0,0,1,.26.23c.16,3,8.22,15.52,8.8,16.42.88.5,12.9,7.26,18.17,5.84a.26.26,0,0,1,.31.18.26.26,0,0,1-.18.3C651.29,202.43,643.23,198.7,639.25,196.63Z",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M616.84,221.33l-.05-.07c-.17-.22-16.4-25.14-15.46-31.11a.25.25,0,0,1,.28-.21.25.25,0,0,1,.21.29c-.86,5.4,13.95,28.72,15.32,30.67,1.6.44,25.11,6.72,30.29,4.91a.25.25,0,0,1,.17.47c-5.49,1.91-29.65-4.64-30.68-4.92Z",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M591.87,253.91l0-.11c-.5-1.26-12.4-30.86-12.94-39a.25.25,0,0,1,.5,0c.52,7.82,12,36.67,12.85,38.74,2.4.63,39.4,10.22,46.94,4.5a.26.26,0,0,1,.35.05.25.25,0,0,1,0,.35c-8,6-45.87-4-47.48-4.46Z",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M442.23,326.78c10.08-8.42,18.51-48.61,11.87-59.44-1.89-3.08-7.12-8.08-14.41-1-4.84,4.72-3.08,6.07-7.7,10.5-1.84,1.77-8.17,5.19-10-2.16-.91-3.73,1.34-10.33,1.86-15.22.23-2.18.51-9.92-4.66-11.93-2.74-1.06-7.84-.28-9.76,5.76-.42,1.3-3.06,5.51-6,4.68,0,0-5.63-2.22-2.77-8.35,0,0,5.58-14.42-3.68-16.28-2-.42-5.3.22-6.64,6.48,0,0-2.57,6.33-6.41,2.71,0,0-.67-.87-2.36-5.61,0,0-4.67-17.1-15.43-8.39-2.83,2.29-6.7,7.25-.77,14.54,0,0,8,6.87,2.49,8.66-3.51,1.15-12.5,2.89-9.59,11.77.47,1.44,4.25,6,13.53,2.34,2-.77,6.91-1.9,9.37.87.45.51,6.71,8.77-7.4,11.51-3.92.77-12.88,7.84-6.26,15,6.39,6.91,17.16,5.44,22.69,3.31,7-2.72,13.36-1.2,13.41,2.93a6.48,6.48,0,0,1-6,5.81c-4.75.11-17-1.28-15.92,12.19.58,6.95,9.83,8.4,22.51,10.91C416.37,330.82,434.45,333.27,442.23,326.78Z",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M437.37,323.59l0,0a.25.25,0,0,1-.34,0c-2.8-3.55-68.47-87-69.33-89.95a.25.25,0,0,1,.17-.3.25.25,0,0,1,.31.16c.66,2.31,45.58,59.74,69.23,89.79A.23.23,0,0,1,437.37,323.59Z",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M385.3,252.64c-1,1.1-1.68,1.82-1.79,1.92l-.09.06c-.62.21-15.07,5-18.25,4.4a.25.25,0,0,1-.19-.29.23.23,0,0,1,.29-.19c3,.6,16.93-4,17.93-4.36.71-.73,10.18-10.57,10.13-16a.25.25,0,1,1,.49,0C393.86,242.54,388.27,249.34,385.3,252.64Z",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M403.42,280.29l-.08,0c-.26.1-28.2,9.48-33.69,7.09a.25.25,0,0,1-.13-.32.24.24,0,0,1,.32-.13c5,2.16,31-6.23,33.24-7.06.82-1.44,12.69-22.42,12.25-27.85a.24.24,0,0,1,.22-.26.25.25,0,0,1,.27.22c.47,5.74-11.83,27.29-12.36,28.2Z",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M428.46,312.35h-.12c-1.33.18-32.68,4.22-40.64,2.71a.23.23,0,0,1-.19-.28.24.24,0,0,1,.28-.2c7.64,1.45,38.17-2.41,40.36-2.7,1.21-2.14,19.61-35.25,16-43.9a.24.24,0,0,1,.13-.32.25.25,0,0,1,.32.13c3.8,9.12-15.28,43-16.09,44.44Z",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M556.36,186.26v-7.61H552.1a15,15,0,0,0-1.49-3.6l3-3-5.38-5.38-3,3a14.78,14.78,0,0,0-3.6-1.49v-4.26H534v4.26a14.62,14.62,0,0,0-3.6,1.49l-3-3L522,172l3,3a14.62,14.62,0,0,0-1.49,3.6h-4.26v7.61h4.26a14.62,14.62,0,0,0,1.49,3.6l-3,3,5.38,5.38,3-3a14.62,14.62,0,0,0,3.6,1.49V201h7.61v-4.26a14.78,14.78,0,0,0,3.6-1.49l3,3,5.38-5.38-3-3a15,15,0,0,0,1.49-3.6Zm-18.54,2.8a6.61,6.61,0,1,1,6.6-6.61A6.61,6.61,0,0,1,537.82,189.06Z",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M572.6,166.82V163h-2.12a7.52,7.52,0,0,0-.75-1.8l1.51-1.51-2.7-2.69-1.5,1.51a7.52,7.52,0,0,0-1.8-.75v-2.13h-3.81v2.13a7.45,7.45,0,0,0-1.79.75L558.13,157l-2.69,2.69,1.51,1.51a7.14,7.14,0,0,0-.75,1.8h-2.13v3.8h2.13a7.14,7.14,0,0,0,.75,1.8l-1.51,1.51,2.69,2.69,1.51-1.51a7.07,7.07,0,0,0,1.79.75v2.13h3.81v-2.13a7.14,7.14,0,0,0,1.8-.75l1.5,1.51,2.7-2.69-1.51-1.51a7.52,7.52,0,0,0,.75-1.8Zm-9.26,1.4a3.3,3.3,0,1,1,3.3-3.3A3.3,3.3,0,0,1,563.34,168.22Z",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 58.92,
    y: 85.27,
    width: 203.72,
    height: 144.26,
    rx: 6.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M585.26,352.7H389.15s2.71,3,11,3H628.55c8.24,0,11-3,11-3Z",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 35.74,
    y: 221.73,
    width: 250.36,
    height: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M532.06,348.49H496.94a2.19,2.19,0,0,0,2.19,2.19h30.74A2.19,2.19,0,0,0,532.06,348.49Z",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 63.2,
    y: 93.11,
    width: 197.35,
    height: 7.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M422,223.26a1.65,1.65,0,1,1-1.65-1.65,1.65,1.65,0,0,1,1.65,1.65",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M427.41,223.26a1.65,1.65,0,1,1-1.65-1.65,1.65,1.65,0,0,1,1.65,1.65",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M432.83,223.26a1.65,1.65,0,1,1-1.65-1.65,1.65,1.65,0,0,1,1.65,1.65",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 63.2,
    y: 100.9,
    width: 197.35,
    height: 116.82
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 163.16,
    y: 108.83,
    width: 83.61,
    height: 98.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 169.59,
    y: 164.43,
    width: 37.79,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 212.14,
    y: 164.43,
    width: 26.55,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 204.85,
    y: 181.08,
    width: 26.55,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 169.82,
    y: 183.58,
    width: 32.04,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 179.45,
    y: 170.42,
    width: 27.93,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 169.82,
    y: 176.42,
    width: 17.44,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 192.54,
    y: 176.42,
    width: 14.84,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 169.59,
    y: 196.44,
    width: 21.89,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 214.75,
    y: 175.88,
    width: 20.65,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 196.11,
    y: 196.44,
    width: 27.42,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 169.59,
    y: 190.44,
    width: 45.16,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 211.77,
    y: 170.42,
    width: 3.43,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.4,
    y: 170.42,
    width: 3.43,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 214.3,
    y: 200.9,
    width: 3.43,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 169.59,
    y: 200.9,
    width: 38.74,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 218.6,
    y: 187.92,
    width: 17.63,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 221.93,
    y: 200.9,
    width: 13.92,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 169.59,
    y: 114.34,
    width: 39.08,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 187.74,
    y: 120.34,
    width: 20.93,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 169.59,
    y: 120.27,
    width: 5.98,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 178.43,
    y: 120.27,
    width: 5.98,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.63,
    y: 120.34,
    width: 27.63,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 213.63,
    y: 114.34,
    width: 27.63,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 206.04,
    y: 136.99,
    width: 27.63,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 169.59,
    y: 139.49,
    width: 33.34,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 169.59,
    y: 126.33,
    width: 39.08,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 169.59,
    y: 132.33,
    width: 18.15,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 193.23,
    y: 132.33,
    width: 15.44,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 170.66,
    y: 152.35,
    width: 21.48,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 216.34,
    y: 131.79,
    width: 21.48,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 196.95,
    y: 152.35,
    width: 28.53,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 170.94,
    y: 146.35,
    width: 45.4,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.24,
    y: 126.33,
    width: 3.57,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 221.18,
    y: 126.33,
    width: 3.57,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 215.87,
    y: 156.81,
    width: 3.57,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 170.66,
    y: 156.81,
    width: 39.01,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 220.35,
    y: 143.83,
    width: 18.34,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 223.81,
    y: 156.81,
    width: 14.49,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 87.6,
    y: 109.03,
    width: 51.31,
    height: 101.7,
    rx: 7.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M483.85,232.77H449.47a10.55,10.55,0,0,0-10.55,10.55v85.46a10.55,10.55,0,0,0,10.55,10.55h34.38a10.55,10.55,0,0,0,10.55-10.55V243.32A10.55,10.55,0,0,0,483.85,232.77Zm8.46,96.16a8,8,0,0,1-8,8H449a8,8,0,0,1-8-8V243.17a8,8,0,0,1,8-8h35.36a8,8,0,0,1,8,8Z",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M472.49,238.78H460.83a4.37,4.37,0,0,1-4.37-4.37h20.4A4.37,4.37,0,0,1,472.49,238.78Z",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 107.35,
    y: 109.54,
    width: 8.44,
    height: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M472.56,236.05a.47.47,0,0,1-.48.48.48.48,0,0,1-.49-.48.49.49,0,0,1,.49-.49A.48.48,0,0,1,472.56,236.05Z",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 93.76,
    y: 137.32,
    width: 38.98,
    height: 38.98,
    rx: 4.23
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "128.76 151.83 113.68 145.33 98.59 151.83 102.63 151.83 102.63 168.3 110.86 168.3 110.86 159.27 116.5 159.27 116.5 168.3 124.72 168.3 124.72 151.83 128.76 151.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M478.61,318.15H455.36a3.82,3.82,0,0,1-3.83-3.83h0a3.83,3.83,0,0,1,3.83-3.84h23.25a3.84,3.84,0,0,1,3.84,3.84h0A3.83,3.83,0,0,1,478.61,318.15Z",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M477.69,317.42h-23a3.84,3.84,0,0,1-3.84-3.83h0a3.84,3.84,0,0,1,3.84-3.84h23a3.83,3.83,0,0,1,3.83,3.84h0A3.83,3.83,0,0,1,477.69,317.42Z",
    transform: "translate(-353.41 -126.17)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-21",
    transform: "translate(107.36 188.7)"
  }, "APP ")), /*#__PURE__*/React.createElement("image", {
    width: 512,
    height: 512,
    transform: "translate(34.59 152.02) scale(0.09)",
    xlinkHref: "../php(1).png"
  }), /*#__PURE__*/React.createElement("image", {
    width: 512,
    height: 512,
    transform: "translate(233.53 193.95) scale(0.1)",
    xlinkHref: "../database.png"
  }), /*#__PURE__*/React.createElement("image", {
    width: 512,
    height: 512,
    transform: "translate(229.83 60.93) scale(0.11)",
    xlinkHref: "../react.png"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4453416);
export default __webpack_public_path__ + "static/media/4453416.117dab5f57ad027c2c2e1da2930303fc.svg";
export { ForwardRef as ReactComponent };